import { Organization } from "../../types/organization";
import { UserDto } from "../user/user.dto";
import { unpackDateOrNull } from "../dto-helpers";

export class OrganizationDto {
    id: string;
    name: string;
    onboardingCompletedAt: string | null;
    createdAt: string;
    primaryAdminUser?: UserDto | null;

    constructor(org: Organization) {
        this.id = org.id;
        this.name = org.name;
        this.onboardingCompletedAt =
            org.onboardingCompletedAt?.toISOString() ?? null;
        this.createdAt = org.createdAt.toISOString();
    }

    static deserialize(dto: OrganizationDto): Organization {
        return {
            id: dto.id,
            name: dto.name,
            onboardingCompletedAt: unpackDateOrNull(dto.onboardingCompletedAt),
            createdAt: new Date(dto.createdAt),
        };
    }
}
